import { useFirebaseToken } from '@/hooks/useFirebaseUser/useFirebaseToken'

import { useNotesServiceGetV1IndividualsByIndividualIdNotes } from '../client/queries'
import { NoteList } from '../client/requests'

export type Note = NoteList[number]

export const useNotes = (individualId?: string) => {
  const token = useFirebaseToken()

  return useNotesServiceGetV1IndividualsByIndividualIdNotes(
    { individualId: individualId! },
    undefined,
    {
      enabled: !!token && !!individualId,
    },
  )
}
